module.exports = __webpack_public_path__ + "img/rectangle1.4d4cd9f4.png";